import NewsletterForm from "@/components/NewsletterForm";
import { T } from "@/lib/texts";

const MAZE_URL = "https://customer-assets-v7afamib.emergentagent.net/job_process-gap/artifacts/qdz7148n_STORIES%20CHALLENGE%20FEBBRAIO%20%284%29.png";

/**
 * NewsletterSection — banda di raccolta email con promessa forte
 * e elemento grafico del marchio (tratti terracotta) sullo sfondo.
 */
export default function NewsletterSection() {
  return (
    <section data-testid="newsletter-section" className="relative overflow-hidden bg-[#EDE7DD] section-pad">
      <img
        src={MAZE_URL}
        alt=""
        aria-hidden="true"
        className="absolute -right-24 -bottom-24 w-[440px] max-w-none opacity-[0.08] pointer-events-none select-none"
      />
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center relative" data-reveal>
        <p className="eyebrow mb-4">Newsletter</p>
        <h2 className="font-display text-4xl sm:text-5xl text-[#2A3229] leading-tight">
          <T k="newsletter_title">Ogni settimana, <span className="text-[#A8674F]">una cosa concreta</span> su cui lavorare.</T>
        </h2>
        <p className="mt-6 text-lg text-[#5A6058] max-w-2xl mx-auto">
          <T k="newsletter_text">Niente teoria e niente spam: un'azione pratica per migliorare la tua impresa, da applicare subito. È la mia promessa.</T>
        </p>
        <div className="mt-10 max-w-md mx-auto">
          <NewsletterForm testidPrefix="newsletter-home" />
        </div>
      </div>
    </section>
  );
}
